import React from 'react';
import Skils from '../components/homePage/Skils'
import PortfolioCards from '../components/homePage/PortfolioCards';

export default function Portfolio() {
  return (
    <div className='container mx-auto justify-center my-24'>
        <h2 className='text-center uppercase text-[56px] lg:text-[100px] text-gray-400 font-light'>portfolio</h2>
        <div className='w-full min-h-[85vh] lg:min-h-[78vh] p-4 bg-indigo mt-16 rounded-3xl flex justify-center items-center shadow-md shadow-deepPurple'>
            <div className='flex flex-wrap justify-center items-center gap-12'>
                <div className='w-56 p-4 h-64 bg-black shadow-2xl shadow-purple rounded-2xl'>
                    <h3 className='text-center text-white font-bold text-[21px]'>Blockchain Projects</h3>
                    <br />
                    <ul className='text-[17px] font-medium text-teal'>
                        <li>DBank</li>
                        <li>DKeeper</li>
                        <li>Opend</li>
                    </ul>
                </div>
                <div className='w-56 p-4 h-64 bg-black shadow-2xl shadow-purple rounded-2xl'>
                    <h3 className='text-center text-white font-bold text-[21px]'>Backend Projects</h3>
                    <br />
                    <ul className='text-[17px] font-medium text-teal'>
                        <li>Iot Systems</li>
                        <li>E-Commerce API's</li>
                        <li>Reservation API's</li>
                        <li>Stock API</li>
                        <li>Tour App</li>
                    </ul>
                </div>
                <div className='w-56 p-4 h-64 bg-black shadow-2xl shadow-purple rounded-2xl'>
                    <h3 className='text-center text-white font-bold text-[21px]'>Websites</h3>
                    <p className='text-indigo text-[21px] font-bold'>For:</p>
                    <ul className='text-[17px] font-medium text-teal'>
                        <li>Companies</li>
                        <li>Personal</li>
                        <li>Blogs</li>
                    </ul>
                </div>
            </div>
        </div>
        <PortfolioCards/>
        <Skils/>
        
    </div>
  )
}
